<template>
  <div class="card">
    <div class="card-image">
      <!-- <figure class="image is-4by3">
        <img src="/img/imperial_trader.jpg" alt="Image">
      </figure> -->
    </div>
    <div class="card-content">
      <div class="content">
        <div class="columns">
          <div class="column">
            <p>Максимум мощности: {{ powerGeneration }}</p>
            <p v-bind:class="maxPowerCunsumptionIndicator">Максимальное потребление: {{ maxPowerCunsumption }}</p>
          </div>
          <div class="column">
            <div v-for="d_index in ship.devices.length" v-bind:key="d_index">
              <div class="select">
                <b-select v-model="ship.devices[d_index-1]" expanded>
                  <option v-bind:value="{}">Пусто</option>
                  <optgroup
                    v-for="row in dict.kinds"
                    v-bind:key="row.kind"
                    v-bind:label="row.desc"
                  >
                    <option
                      v-for='device in devices.filter(item => item.kind === row.kind)'
                      v-bind:value="Object.assign({}, device)"
                    >{{ dict[device.type] }}: {{ device.name }}</option>
                  </optgroup>
                </b-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShipService from '../services/TestBattleShipService'
export default {
  props: ['ship', 'devices'],
  data: function () {
    return {
      // currentStrength: this.user.ship.current_strength,
      dict: {
        kinds: [
          { kind: 'weapon', desc: 'Вооружение' },
          { kind: 'protector', desc: 'Защита' },
          { kind: 'energy', desc: 'Источник энергии' },
        ],
        laser: 'Лазер',
        rocket: 'Ракетная установка',
        energetic_field: 'Силовой щит',
        missile_traps: 'Противоракетные ловушки',
        atom: 'Реактор'
      },
    }
  },
  computed: {
    powerGeneration: function() {
      return ShipService.calculatePowerGeneration(this.ship.devices)
    },
    maxPowerCunsumption: function () {
      return ShipService.calculateMaxPowerConsumption(this.ship.devices)
    },
    maxPowerCunsumptionIndicator: function() {
      switch (true) {
        case (this.powerGeneration - this.maxPowerCunsumption > 0):
          return "has-text-success-dark"
        case (this.powerGeneration - this.maxPowerCunsumption === 0):
          return "has-text-info-dark"
        case (this.powerGeneration - this.maxPowerCunsumption < 0):
          return "has-text-danger-dark"
      }
      
    },
  },
  methods: {
  },
}
</script>